export enum OrganizationTypeEnum {
    ORG_UNKNOWN = 'ORG_UNKNOWN',
    ORG_DRONE_OPERATOR = 'ORG_DRONE_OPERATOR',
    ORG_INFRASTRUCTURE_OPERATOR = 'ORG_INFRASTRUCTURE_OPERATOR',
    ORG_SERVICE_PROVIDER = 'ORG_SERVICE_PROVIDER',
    ORG_NATURAL_PARC_OPERATOR = 'ORG_NATURAL_PARC_OPERATOR',
    ORG_PUBLIC_SAFETY_OPERATOR = 'ORG_PUBLIC_SAFETY_OPERATOR',
    ORG_TRACK_NETWORK_OPERATOR = 'ORG_TRACK_NETWORK_OPERATOR',
    ORG_HARBOUR_OPERATOR = 'ORG_HARBOUR_OPERATOR',
}

export function getOrganizationTypeLabel(type: OrganizationTypeEnum): string {
    switch (type) {
        case OrganizationTypeEnum.ORG_UNKNOWN:
            return 'Other';
        case OrganizationTypeEnum.ORG_DRONE_OPERATOR:
            return 'Drone Organization';
        case OrganizationTypeEnum.ORG_INFRASTRUCTURE_OPERATOR:
            return 'Infrastructure Organization';
        case OrganizationTypeEnum.ORG_SERVICE_PROVIDER:
            return 'Service Provider';
        case OrganizationTypeEnum.ORG_NATURAL_PARC_OPERATOR:
            return 'Natural Park Organization';
        case OrganizationTypeEnum.ORG_PUBLIC_SAFETY_OPERATOR:
            return 'Public Safety Organization';
        case OrganizationTypeEnum.ORG_TRACK_NETWORK_OPERATOR:
            return 'Track Network Organization';
        case OrganizationTypeEnum.ORG_HARBOUR_OPERATOR:
            return 'Harbour Organization';
        default:
            return 'Unknown Type';
    }
}